<template>
	<div>
		<div v-if="Profile.Contact.GivenName" class="d21-profile__header">
			{{ Profile.Contact.GivenName }} {{ Profile.Contact.LastName }}
			<div class="d21-profile__logo">
				{{ Profile.Contact.GivenName[0] }} {{ Profile.Contact.LastName[0] }}
			</div>
		</div>
		<div class="d21-profile__content d21-profile__nav">
			<ul>
				<li @click="goTo('settings')">
					<i class="material-icons icon">settings</i>
					{{ T("ticketing_profile_settings") }}
					<i class="material-icons">navigate_next</i>
				</li>
				<li @click="goTo('reservations')">
					<i class="material-icons icon">book_online</i>
					{{ T("ticketing_profile_bookings") }}
					<i class="material-icons">navigate_next</i>
				</li>
				<li v-if="false">
					<i class="material-icons icon">chat</i>
					{{ T("ticketing_profile_contacts") }}
					<i class="material-icons">navigate_next</i>
				</li>
				<li v-if="false">
					<i class="material-icons icon">receipt</i>
					{{ T("ticketing_profile_receipts") }}
					<i class="material-icons">navigate_next</i>
				</li>
			</ul>
			<ul>
				<li @click="backToApp">
					<i class="material-icons icon information">more</i>
					{{ T("ticketing_back_to_booking") }}
					<i class="material-icons">navigate_next</i>
				</li>
				<li @click="logout">
					<i class="material-icons icon">logout</i>
					{{ T("ticketing_log_out") }}
					<i class="material-icons">navigate_next</i>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import base from "../mixins/base";
	import 'vueperslides/dist/vueperslides.css'

	export default {
		mixins: [base],
		components: {},
		name: "d21-profile-nav",
		data() {
			return {}
		},
		methods: {
			logout() {
				this.onSetProfile(null);
				this.$router.push(`/${this.$route.params.channel}`);
			},
			backToApp() {
				this.$router.push(`/${this.$route.params.channel}`);
			},
			goTo(section) {
				this.$router.push(`/${this.$route.params.channel}/profile/${section}`);
			}
		},
	}
</script>